module.exports = __webpack_public_path__ + "img/handmade-level__dark.d353a19e.svg";